import React from 'react';
import Modal from '../../../components/ui/Modal';
import { embedUrl } from '../AvLibrary/data/videos';

// The Cloudflare Stream player in an overlay. Used by the Av Library section
// pages and by the Av Library dropdown on the CyberFraud Alert / ScamWire
// pages (10-28), so a video picked from an alert plays right there and
// closing it leaves the reader exactly where they were.
const VideoPlayerModal = ({ video, onClose }) => (
  <Modal isOpen={!!video} onClose={onClose} size="xlarge">
    {video && (
      <div className="relative w-full bg-black" style={{ aspectRatio: '16 / 9' }}>
        <iframe
          src={embedUrl(video)}
          title={video.title}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          className="absolute inset-0 w-full h-full border-0"
        />
      </div>
    )}
  </Modal>
);

export default VideoPlayerModal;
